// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ef9R","content":"styles_content__3H9ys"};